// 使用教程
// import apiInterface from '@/api/index'; //引入接口api；
// async login() {
// 如果改成同步必须接口  方法前面必须加 async  ajax 前面必须  await this.$xhr 才可以执行
// 写法一：POST方法
// try {
//   let pdata = await this.$xhr.post(apiInterface.login, {
//     account: 'teacher@lehua.com',
//     captcha: '3414',
//     password: 'abc12345'
//   })
// } catch (error) {
// };
// 写法二：POST方法 post('接口地址',{需要传递的参数})
// this.$xhr.post(apiInterface.login,{account:'teacher@lehua.com',captcha:'3414',password:'abc12345'}).then(res=>{
//   console.log(res)
// }).catch(err =>{
// });
// 写法三：GET方法 get('接口地址',{params:{需要传递的参数}})
// this.$xhr.get(apiInterface.login,{params:{account:'teacher@lehua.com',captcha:'3414',password:'abc12345'}}).then(red =>{
// }).catch(err =>{
// });
// },
// 引入需要判断生产环境或者开发环境
import LH from './domain'

const ApiUrl = {
  // 用户相关
  login: LH + '/users/login', // 登录接口 POST
  userInfo: LH + '/users/info', // 登录接口 GET
  signup: LH + '/users/signup', // 用户注册 POST
  resetpasswordForget: LH + '/users/reset-password-by-forget', // 忘记密码 POST
  smsCaptcha: LH + '/users/get-sms-captcha', // 获取手机短信验证码 GET
  phoneLogin: LH + '/users/login', // 用户手机验证码登录 POST
  getEmailCaptcha: LH + '/users/get-email-captcha', // 获取邮件验证码 GET
  resetPassword: LH + '/users/reset-password-by-forget', // 忘记密码 POST
  // 个人中心
  teachersProfileUpdate: LH + '/teachers/profile-update', // 教师个人信息更新 POST
  certificateUpload: LH + '/teachers/certificate/upload', // 教师资格证上传 POST
  audit: LH + '/teachers/audit', // 教师提交审核 POST
  inVerification: LH + '/teacher/resources/in-verification', // 正在审核中的作品资源(教师) GET
  resources: LH + '/teachers/resources', // 教学资源(教师) GET
  works: LH + '/teachers/works', // 作品集(教师) GET
  studentsProfileUpdate: LH + '/students/profile-update', // 学生个人信息更新 POST
  studentsDownloads: LH + '/student/downloads', // 我的下载(学生) GET
  studentsWorks: LH + '/student/works', // 我的作品(学生) GET
  verification: LH + '/resources/in-verification', // 资源审核列表（教师）
  inverification: LH + '/works/in-verification', // 作品审核列表
  myStudentsWorks: LH + '/students/works', // 学生我的作品
  myStudentsDownloaded: LH + '/students/downloaded-resources', // 学生我的下载
  avatarUpload: LH + '/users/avatar-upload', // 更新个人头像（学生教师通用） POST 新
  // 资源相关
  resourcesList: LH + '/resources', // 资源列表 GET
  resourcesDtels: LH + '/resources/', // 资源详情 GET
  resourceStore: LH + '/resources/store', // 资源上传 POST
  thumbUp: LH + '/resources/', // 资源点赞与资源下载共用一个接口 POST
  // 作品相关
  worksList: LH + '/works', // 作品列表 GET
  worksDtels: LH + '/works/', // 作品详情 GET
  worksThumbUp: LH + '/works/', // 作品点赞 POST
  shareImg: LH + '/works/share-img/:id.jpg', // 作品分享图 GET
  worksStore: LH + '/works/store', // 作品上传 POST
  worksRate: LH + '/works/', // 作品评价
  worksTeacherAudit: LH + '/works/', // 作品审核 教师作品
  worksStudentAudit: LH + '/works/', // 作品审核 学生作品
  // 未分类
  bannersList: LH + '/banners', // Banner列表  GET
  schoolsList: LH + '/schools', // 学校列表 GET
  workTypes: LH + '/work-types', // 作品类型列表 GET
  schoolTeachersList: LH + '/school-teachers', // 获取学校的老师列表 GET
  workComments: LH + '/work-comments',   // 作品评语列表
  worksUploadFile: LH + '/works/upload-file', // 上传作品文件  POST
}
export default ApiUrl


